import React, { createContext, useContext, useMemo } from 'react';
import { ResolvedTenant } from 'types/tenant';
import { getResolvedTenant } from 'config/resolvedTenant';

interface TenantContextValue {
  tenant: ResolvedTenant;
  tenantCode: string;
  tenantId: number;
}

const TenantContext = createContext<TenantContextValue | undefined>(undefined);

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const tenant = getResolvedTenant();
  if (!tenant) {
    throw new Error('TenantProvider requiere tenant resuelto antes del render');
  }

  const value = useMemo(
    () => ({
      tenant,
      tenantCode: tenant.tenantCode,
      tenantId: tenant.tenantId,
    }),
    [tenant]
  );

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
};

export const useTenantContext = () => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenantContext debe usarse dentro de TenantProvider');
  return ctx;
};
